import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageIcon, TagIcon, TrendingUpIcon } from 'lucide-react';
interface BrandCardProps {
  brand: {
    id: number;
    name: string;
    logo: string;
    category: string;
    productCount: number;
    discount: number;
    description: string;
    isFeatured: boolean;
  };
}
export function BrandCard({
  brand
}: BrandCardProps) {
  const navigate = useNavigate();
  return <div onClick={() => navigate(`/brand/${brand.name.toLowerCase().replace(/\s+/g, '-')}`)} className="bg-white rounded-xl transition-all duration-300 overflow-hidden cursor-pointer group border border-gray-100 hover:border-gray-200" data-id="element-5343" data-mp="1ye3ifcdl1oen">
      {/* Logo Section */}
      <div className="relative bg-gray-50 p-6 h-40 flex items-center justify-center" data-id="element-5344" data-mp="2d2q5y1dd5mgy">
        {brand.isFeatured && <div className="absolute top-3 right-3 bg-yellow-50 text-yellow-700 border border-yellow-100 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1" data-id="element-5345" data-mp="1fm0y9r1qfpzn">
            <TrendingUpIcon className="w-3 h-3" data-id="element-5346" data-mp="2w1fg6uth43gz" />
            Featured
          </div>}
        <img src={brand.logo} alt={brand.name} className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300" data-id="element-5347" data-mp="2r34a8v6aud41" />
      </div>
      {/* Content Section */}
      <div className="p-4" data-id="element-5348" data-mp="2hdawpomljnx5">
        <h3 className="font-bold text-gray-900 mb-1 group-hover:text-[#1E2B55] transition-colors" data-id="element-5349" data-mp="2dbzei461y4yz">
          {brand.name}
        </h3>
        <p className="text-xs text-gray-600 mb-3 line-clamp-1" data-id="element-5350" data-mp="28cmqhg3g2rut">
          {brand.description}
        </p>
        {/* Stats */}
        <div className="flex items-center justify-between mb-3" data-id="element-5351" data-mp="23ebh16h2ajd4">
          <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-5352" data-mp="1yfi69lt5t6gn">
            <PackageIcon className="w-4 h-4" data-id="element-5353" data-mp="1m6jnfgsmtv0" />
            <span data-id="element-5354" data-mp="1l54ozwnpn80">{brand.productCount} Products</span>
          </div>
          {brand.discount > 0 && <div className="flex items-center gap-1 text-sm text-green-600 font-bold" data-id="element-5355" data-mp="3st99o3kwau3n">
              <TagIcon className="w-4 h-4" data-id="element-5356" data-mp="1r2sdfl0eqyfz" />
              <span data-id="element-5357" data-mp="1vuad85qp2szd">Up to {brand.discount}% OFF</span>
            </div>}
        </div>
        {/* Shop Button */}
        <button className="w-full bg-[#1E2B55] text-white py-2 rounded-lg font-medium hover:bg-[#162041] transition-colors" data-id="element-5358" data-mp="1h5wbjy50lake">
          Shop Now
        </button>
      </div>
    </div>;
}